/**
 * DanceSettings.tsx
 * Danceカードの設定ダイアログの中身（ダンス選択）
 */
import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { DEFAULT_DANCE_MOTION_ID, DANCE_MOTIONS } from '../../config/danceMotions';
import { useFlowDisplayLanguage } from '../../displayLanguage';

export function DanceSettings({ node }: NodeSettingsProps<'dance'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <label className="block" data-product-tour="card-input-1">
      <span className="mb-1 block text-sm font-medium text-slate-700">
        {displayLanguage === 'en' ? 'dance' : 'ダンス'}
      </span>
      <select
        value={node.data.motionId ?? DEFAULT_DANCE_MOTION_ID}
        onChange={(event) => updateNodeData(node.id, { motionId: event.target.value })}
        className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-rose-400"
      >
        {DANCE_MOTIONS.map((option) => (
          <option key={option.id} value={String(option.id)}>{option.label}</option>
        ))}
      </select>
    </label>
  );
}
